<template>
    <div class="permission-user">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>用户权限管理</span>
            </div>

            <!-- 搜索区域 -->
            <div class="search-area">
                <el-input v-model="searchKeyword" placeholder="请输入用户ID/账号名/手机号/权限搜索"
                    style="width: 320px; margin-right: 10px" clearable @keyup.enter.native="handleSearch">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-button type="primary" @click="handleSearch">搜索</el-button>
                <el-button @click="resetSearch">重置</el-button>

                <!-- 添加用户权限按钮 -->
                <el-button type="primary" @click="handleAdd" style="margin-left: auto">
                    添加运营账号
                </el-button>
            </div>

            <!-- 用户权限表格 -->
            <el-table :data="filteredTableData" style="width: 100%; margin-top: 20px" v-loading="loading" border stripe>
                <el-table-column type="index" label="序号" width="80" align="center" header-align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="账号ID" align="center">
                </el-table-column>
                <el-table-column prop="name" label="账号名" align="center">
                </el-table-column>
                <el-table-column prop="phone" label="手机号" width="200" align="center">
                                        <template slot-scope="scope">
                        <el-tag type="success" size="small">
                            {{ scope.row.phone }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="roleId" label="权限ID" width="120" align="center">
                    <!-- <template slot-scope="scope">
                        <el-tag :type="getPermissionTagType(scope.row.roleId)" size="small">
                            {{ scope.row.roleId }}
                        </el-tag>
                    </template> -->
                </el-table-column>
                <el-table-column prop="roleName" label="权限名称" width="180" align="center">
                </el-table-column>
                <el-table-column label="操作" width="200" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="handleEdit(scope.row)">
                            权限编辑
                        </el-button>
                        <el-button type="danger" size="mini" @click="handleDelete(scope.row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>


        <!-- 添加/编辑用户权限对话框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" @close="handleDialogClose">
            <el-form ref="formRef" :model="formData" :rules="formRules" label-width="100px">
                <el-form-item label="账号ID" prop="userId">
                    <el-input v-model="formData.userId" placeholder="请输入用户ID（仅限数字和字母）" :disabled="isEditMode"
                        autocomplete="off">
                    </el-input>
                </el-form-item>
                <el-form-item label="账号名" prop="userName">
                    <el-input v-model="formData.userName" placeholder="请输入用户名" :disabled="isEditMode"
                        autocomplete="new-username">
                    </el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password" v-if="!isEditMode">
                    <el-input v-model="formData.password" placeholder="请输入密码" type="password" show-password
                        autocomplete="new-password">
                    </el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone" v-if="!isEditMode">
                    <el-input v-model="formData.phone" placeholder="请输入手机号" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="权限名称" prop="roleName">
                    <el-select v-model="formData.roleName" placeholder="请选择权限名称" style="width: 100%"
                        @change="handleRoleNameChange" :loading="roleLoading">
                        <el-option v-for="role in roleOptions" :key="role.id" :label="role.description"
                            :value="role.name">
                            <span style="float: left">{{ role.description }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">ID: {{ role.id }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="权限ID" prop="roleId">
                    <el-input v-model.number="formData.roleId" placeholder="权限ID将根据权限名称自动填充" type="number"
                        disabled></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'PermissionUser',
    data() {
        // 用户ID正则校验规则：只能包含数字和字母
        const validateUserId = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入用户ID'))
                return
            }

            // 检查是否只包含数字和字母
            if (/^[a-zA-Z0-9]+$/.test(value)) {
                callback()
                return
            }

            callback(new Error('用户ID只能包含数字和字母，不能包含中文或特殊符号'))
        }

        // 手机号验证规则
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入手机号'))
                return
            }

            // 简单的手机号验证：11位数字
            if (/^1[3-9]\d{9}$/.test(value)) {
                callback()
                return
            }

            callback(new Error('请输入正确的手机号格式'))
        }

        return {
            // 搜索表单
            // searchForm: {
            //     roleUserId: ''
            // },
            // 搜索关键词
            searchKeyword: '',
            // 表格数据
            tableData: [],
            // 加载状态
            loading: false,
            // 对话框显示状态
            dialogVisible: false,
            // 是否为编辑模式
            isEditMode: false,
            // 对话框标题
            dialogTitle: '添加运营账号',
            // 表单数据（根据RoleUserInfo类调整）
            formData: {
                userId: '',           // 账号ID
                userName: '',         // 账号名
                password: '',         // 密码（仅添加时需要）
                phone: '',            // 手机号（仅添加时需要）
                roleId: null,         // 新权限ID
                ordRoleId: null,      // 原始权限ID（编辑时需要）
                roleName: ''          // 权限名称（用于显示和选择）
            },
            // 权限选项列表
            roleOptions: [],
            // 权限列表加载状态
            roleLoading: false,
            // 表单验证规则
            formRules: {
                userId: [
                    { required: true, message: '请输入用户ID', trigger: 'blur' },
                    { validator: validateUserId, trigger: 'blur' }
                ],
                userName: [
                    { required: true, message: '请输入用户名', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: validatePhone, trigger: 'blur' }
                ],
                roleName: [
                    { required: true, message: '请选择权限名称', trigger: 'change' }
                ],
                roleId: [
                    { required: true, message: '权限ID不能为空', trigger: 'blur' }
                ]
            }
        }
    },
    created() {
        this.queryRoleUserList()
        this.fetchRoleOptions()
    },
    computed: {
        // 过滤后的表格数据（前端搜索）
        filteredTableData() {
            if (!this.searchKeyword.trim()) {
                return this.tableData
            }

            const keyword = this.searchKeyword.toLowerCase()
            return this.tableData.filter(item =>
                (item.id && item.id.toString().toLowerCase().includes(keyword)) ||
                (item.name && item.name.toLowerCase().includes(keyword)) ||
                (item.phone && item.phone.toLowerCase().includes(keyword)) ||
                (item.roleId && item.roleId.toString().toLowerCase().includes(keyword)) ||
                (item.roleName && item.roleName.toLowerCase().includes(keyword))
            )
        }
    },
    methods: {
        // API调用：查询用户权限列表
        async queryRoleUserList() {
            this.loading = true
            try {
                const response = await this.$axios.get('/web/roleUserList/query')
                console.log('获取用户权限列表响应:', response.data)

                if (response.data.status === 200) {
                    // 直接使用接口返回的数据，字段名已更新为：id, name, phone, roleId, roleName
                    this.tableData = response.data.object || []
                    console.log('表格数据:', this.tableData)
                } else {
                    this.$message.error(response.data.msg || '获取用户权限列表失败')
                }
            } catch (error) {
                console.error('获取用户权限列表失败:', error)
                this.$message.error('获取用户权限列表失败')
            } finally {
                this.loading = false
            }
        },

        // API调用：获取权限列表（用于下拉框）
        async fetchRoleOptions() {
            this.roleLoading = true
            try {
                const response = await this.$axios.get('/web/roleList/query')
                console.log('获取权限列表响应:', response.data)

                if (response.data.status === 200) {
                    this.roleOptions = response.data.object || []
                    console.log('权限选项列表:', this.roleOptions)
                } else {
                    this.$message.error(response.data.msg || '获取权限列表失败')
                }
            } catch (error) {
                console.error('获取权限列表失败:', error)
                this.$message.error('获取权限列表失败')
            } finally {
                this.roleLoading = false
            }
        },

        // API调用：添加用户权限
        async addRoleUser(data) {
            try {
                // 根据RegistryInfo类的要求构建请求数据
                const requestData = {
                    id: data.userId,           // 账号ID
                    name: data.userName,       // 账号名
                    password: data.password,   // 密码
                    roleId: data.roleId,       // 权限ID
                    phone: data.phone          // 手机号
                }
                console.log('添加用户权限请求参数:', requestData)

                const response = await this.$axios.post('/web/roleUser/add', requestData)
                console.log('添加用户权限响应:', response.data)
                return response.data
            } catch (error) {
                console.error('添加用户权限失败:', error)
                throw error
            }
        },

        // API调用：更新用户权限（使用新的RoleUserInfo格式）
        async updateRoleUser(data) {
            try {
                // 根据RoleUserInfo类的要求构建请求数据
                const requestData = {
                    userId: data.userId,        // 账号ID
                    userName: data.userName,    // 账号名
                    roleId: data.roleId,        // 新权限ID
                    ordRoleId: data.ordRoleId,  // 原始权限ID
                    roleName: data.roleName     // 权限名称
                }
                console.log('更新用户权限请求参数:', requestData)

                const response = await this.$axios.post('/web/roleUser/update', requestData)
                console.log('更新用户权限响应:', response.data)
                return response.data
            } catch (error) {
                console.error('更新用户权限失败:', error)
                throw error
            }
        },

        // API调用：删除用户权限
        async deleteRoleUser(userId) {
            try {
                const response = await this.$axios.post('/web/roleUser/delete', null, {
                    params: { userId }
                })
                console.log('删除用户权限响应:', response.data)
                return response.data
            } catch (error) {
                console.error('删除用户权限失败:', error)
                throw error
            }
        },

        // 权限名称选择变化处理
        handleRoleNameChange(roleName) {
            // 根据选择的权限名称找到对应的权限ID
            const selectedRole = this.roleOptions.find(role => role.name === roleName)
            if (selectedRole) {
                this.formData.roleId = selectedRole.id
                this.formData.roleName = roleName
            } else {
                this.formData.roleId = null
                this.formData.roleName = ''
            }
        },
                // 获取权限标签类型
        getPermissionTagType(status) {
            const typeMap = {
                2001: 'warning',  // 审核人员
                3001: 'danger',   // 系统管理员
                4001: 'info'      // 测试修改
            }
            return typeMap[status] || 'info'
        },


        // 搜索
        handleSearch() {
            // 使用computed属性自动过滤，这里不需要额外处理
        },

        // 重置搜索
        resetSearch() {
            this.searchKeyword = ''
        },

        // 打开添加对话框
        handleAdd() {
            this.isEditMode = false
            this.dialogTitle = '添加运营账号'
            this.resetFormData()
            this.dialogVisible = true
        },

        // 打开编辑对话框
        handleEdit(row) {
            this.isEditMode = true
            this.dialogTitle = '编辑账号权限'
            this.formData = {
                userId: row.id,                 // 用户ID（接口返回字段名为id）
                userName: row.name,             // 用户名（接口返回字段名为name）
                password: '',                   // 编辑时不显示密码
                phone: row.phone || '',         // 手机号（接口返回字段名为phone）
                roleId: row.roleId,             // 新权限ID（初始为当前权限ID）
                ordRoleId: row.roleId,          // 原始权限ID（保存当前权限ID）
                roleName: row.roleName          // 权限名称
            }
            this.dialogVisible = true
        },

        // 删除用户权限
        handleDelete(row) {
            this.$confirm(`确定要删除用户 "${row.name}" 的权限吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const response = await this.deleteRoleUser(row.id)
                    if (response.status === 200) {
                        this.$message.success('删除成功')
                        this.queryRoleUserList()
                    } else {
                        this.$message.error(response.object || '删除失败')
                    }
                } catch (error) {
                    console.error('删除用户权限失败:', error)
                    this.$message.error('删除失败')
                }
            }).catch(() => {
                // 用户取消删除
            })
        },

        // 提交表单
        handleSubmit() {
            this.$refs.formRef.validate(async (valid) => {
                if (valid) {
                    try {
                        if (this.isEditMode) {
                            // 编辑账号权限 - 使用RoleUserInfo格式
                            const response = await this.updateRoleUser(this.formData)
                            if (response.status === 200) {
                                this.$message.success('更新成功')
                                this.dialogVisible = false
                                this.queryRoleUserList()
                            } else {
                                this.$message.error(response.object || '更新失败')
                            }
                        } else {
                            // 添加运营账号 - 使用RegistryInfo格式
                            const response = await this.addRoleUser(this.formData)
                            if (response.status === 200) {
                                this.$message.success('添加成功')
                                this.dialogVisible = false
                                this.queryRoleUserList()
                            } else {
                                this.$message.error(response.object || '添加失败')
                            }
                        }
                    } catch (error) {
                        console.error('操作失败:', error)
                        this.$message.error('操作失败')
                    }
                }
            })
        },

        // 重置表单数据
        resetFormData() {
            this.formData = {
                userId: '',
                userName: '',
                password: '',
                phone: '',
                roleId: null,
                ordRoleId: null,
                roleName: ''
            }
        },

        // 对话框关闭处理
        handleDialogClose() {
            this.$refs.formRef.resetFields()
            this.resetFormData()
        }
    }
}
</script>

<style scoped>
.permission-user {
    padding: 20px;
}

.box-card {
    min-height: calc(100vh - 100px);
}

.search-area {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}

.el-table {
    margin-top: 20px;
}

.el-button+.el-button {
    margin-left: 10px;
}
</style>